const dailyMetrics = [
  {
    icon: 'ri-search-eye-line',
    text: 'Аудит и оптимизация кампаний: ищем очевидные ошибки, отключаем неэффективные ключи и объявления — снижаем стоимость заявки.',
  },
  {
    icon: 'ri-arrow-up-circle-line',
    text: 'Находим самые эффективные (конверсионные) запросы и поднимаем на них ставки.',
  },
  {
    icon: 'ri-money-cny-circle-line',
    text: 'Количество конверсий (заявок/звонков) и их стоимость (CPA/Цена цели) — главная метрика окупаемости рекламы.',
  },
  {
    icon: 'ri-cursor-line',
    text: 'Показатель кликабельности (CTR) — насколько наши объявления привлекательны для аудитории.',
  },
  {
    icon: 'ri-bar-chart-2-line',
    text: 'Процент отказов: аналитика дорогих лидов по кампаниям и их последующая оптимизация.',
  },
  {
    icon: 'ri-wallet-3-line',
    text: 'Расход бюджета и средняя цена клика (CPC) — чтобы не было оплаты за неэффективные переходы.',
  },
  {
    icon: 'ri-filter-3-line',
    text: 'Правило Парето в сетях (РСЯ): 20% площадок тратят 80% бюджета. Регулярная чистка из показов.',
  },
];

const analyticsPoints = [
  {
    icon: 'ri-git-branch-line',
    title: 'Умные модели атрибуции',
    text: 'Клиенты редко покупают сразу. Человек может зайти с Яндекс.Директа, потом вернуться из поисковика, а купить, перейдя из соцсетей. Мы используем модель «Последний значимый переход», чтобы точно определить, какая реклама привела к продаже, и не отключить кампании, подогревающие интерес.',
  },
  {
    icon: 'ri-bug-line',
    title: 'Поиск «протечек» и «прецедентов»',
    text: 'Аналитика нужна для поиска мест на сайте, где вы теряете клиентов («протечки»), и выявления самых прибыльных связок («прецеденты»), чтобы масштабировать их. Следим за нормами: процент отказов — 5–20%, время на сайте — строго больше 30 секунд.',
  },
];

export default function ContextAdsMetrics() {
  return (
    <section id="context-ads-metrics" className="py-12 sm:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        {/* Header */}
        <div className="text-center mb-8 sm:mb-14">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#1A2B4C]/08 border border-[#1A2B4C]/15 mb-5">
            <i className="ri-pulse-line text-[#C5A880] text-sm"></i>
            <span className="text-[#1A2B4C] text-xs font-bold font-['Montserrat'] uppercase tracking-widest">
              ежемесячный Контроль показателей
            </span>
          </div>
          <h2 className="text-2xl sm:text-4xl md:text-5xl font-['Playfair_Display'] font-bold text-[#1A2B4C] mb-4 leading-tight max-w-4xl mx-auto">
            Что делает специалист и какие показатели отслеживает?
          </h2>
          <div className="w-16 h-1 bg-[#C5A880] mx-auto mb-5 rounded-full"></div>
          <div className="max-w-3xl mx-auto">
            <p className="text-sm sm:text-base text-[#1A2B4C]/70 leading-relaxed font-['Montserrat'] text-justify">
              Работа не заканчивается после запуска рекламы.{' '}
              <strong className="text-[#1A2B4C]">Запуск — это только 20% успеха.</strong>{' '}
              Остальные 80% — это жёсткий аналитический контроль.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-10 mb-10">
          {/* Left — key metrics list */}
          <div>
            <h3 className="text-base sm:text-lg font-bold text-[#1A2B4C] font-['Playfair_Display'] mb-5 flex items-center gap-2">
              <i className="ri-list-check-3 text-[#C5A880] text-lg"></i>
              Отслеживаемые ключевые метрики бизнеса
            </h3>
            <div className="space-y-3">
              {dailyMetrics.map((item, i) => (
                <div
                  key={i}
                  className="flex items-start gap-3 bg-[#F9F5EF] rounded-xl px-4 py-3 border border-[#C5A880]/15"
                >
                  <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                    <i className={`${item.icon} text-lg text-[#C5A880]`}></i>
                  </div>
                  <p className="text-sm text-[#1A2B4C]/75 leading-relaxed font-['Montserrat'] text-justify">
                    {item.text}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Right — deep analytics */}
          <div>
            <h3 className="text-base sm:text-lg font-bold text-[#1A2B4C] font-['Playfair_Display'] mb-5 flex items-center gap-2">
              <i className="ri-microscope-line text-[#C5A880] text-lg"></i>
              Глубокая веб-аналитика
            </h3>
            <div className="space-y-4">
              {analyticsPoints.map((item, i) => (
                <div
                  key={i}
                  className="bg-[#1A2B4C] rounded-2xl p-5 sm:p-6"
                >
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-[#C5A880]/20 border border-[#C5A880]/30 flex-shrink-0">
                      <i className={`${item.icon} text-[#C5A880] text-lg`}></i>
                    </div>
                    <h4 className="text-white font-bold text-sm sm:text-base font-['Playfair_Display'] leading-snug">
                      {item.title}
                    </h4>
                  </div>
                  <p className="text-white/70 text-sm leading-relaxed font-['Montserrat'] text-justify">
                    {item.text}
                  </p>
                </div>
              ))}

              {/* Нормы */}
              <div className="bg-[#F9F5EF] rounded-2xl border border-[#C5A880]/25 p-5">
                <p className="text-xs font-bold text-[#C5A880] uppercase tracking-widest font-['Montserrat'] mb-3">
                  Нормативные показатели
                </p>
                <div className="grid grid-cols-2 gap-3">
                  <div className="text-center bg-white rounded-xl py-3 border border-[#C5A880]/15">
                    <p className="text-xl font-bold text-[#1A2B4C] font-['Playfair_Display']">5–20%</p>
                    <p className="text-xs text-[#1A2B4C]/60 font-['Montserrat'] mt-0.5">Процент отказов</p>
                  </div>
                  <div className="text-center bg-white rounded-xl py-3 border border-[#C5A880]/15">
                    <p className="text-xl font-bold text-[#1A2B4C] font-['Playfair_Display']">&gt;30 сек</p>
                    <p className="text-xs text-[#1A2B4C]/60 font-['Montserrat'] mt-0.5">Время на сайте</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="bg-gradient-to-r from-[#1A2B4C] to-[#253D6B] rounded-2xl sm:rounded-3xl px-6 sm:px-12 py-8 sm:py-10 text-center">
          <h3 className="text-xl sm:text-2xl font-['Playfair_Display'] font-bold text-white mb-6 leading-tight max-w-2xl mx-auto">
            Запишитесь на консультацию. Мы разберём вашу ситуацию и подберём решение!
          </h3>
          <a
            href="#context-ads-form"
            className="inline-flex items-center gap-2 bg-[#C5A880] hover:bg-[#B39770] text-white px-7 py-4 rounded-xl font-semibold text-sm font-['Montserrat'] transition-all duration-300 hover:scale-[1.02] cursor-pointer whitespace-nowrap"
          >
            <i className="ri-customer-service-2-line"></i>
            Получить консультацию
          </a>
        </div>
      </div>
    </section>
  );
}
